import React, { useState, useEffect } from "react";
import { Form, InputNumber, Input, Select, Typography } from "antd";
import { useTranslation } from "react-i18next";
import axios from "axios";
import { elvis } from "../../Utils"

const { Title } = Typography;
const { Option } = Select;

const StaffForm = props => {
  const [form] = Form.useForm();
  const isEditMode = props.isEditMode || false;
  const { t } = useTranslation();
  const [staffCategories, setStaffCategories] = useState([]);

  useEffect(() => {
    axios
      .get(process.env.REACT_APP_API_ENDPOINT + "/business/enums/staff-categories")
      .then(({ data }) => setStaffCategories(data))
      .catch(error => console.log(error));
  }, []);

  const formItemLayout = {
    labelCol: {
      sm: { span: 8 }
    },
    wrapperCol: {
      sm: { span: 16 }
    }
  };

  // Initialize form with record data
  useEffect(() => {
    if (props.record.asset) {
      form.setFieldsValue({
        number: props.record.asset.number,
        activities: props.record.asset.activities,
        staffCategory: props.record.asset.staffCategory,
        details: props.record.asset.details
      });
    }
  }, [props.record.asset, form]);

  // Reset form when exiting edit mode
  useEffect(() => {
    if (!isEditMode && props.record.asset) {
      form.resetFields();
      form.setFieldsValue({
        number: props.record.asset.number,
        activities: props.record.asset.activities,
        staffCategory: props.record.asset.staffCategory,
        details: props.record.asset.details
      });
    }
  }, [isEditMode, form, props.record.asset]);

  // Handle form changes and notify parent
  const handleFormChange = () => {
    if (!isEditMode) return;
    
    const values = form.getFieldsValue();
    const errors = form.getFieldsError();
    const isValid = errors.every(error => !error.errors.length);
    
    const newAsset = { ...props.record };
    newAsset.asset.number = elvis(values.number);
    newAsset.asset.activities = elvis(values.activities);
    newAsset.asset.staffCategory = elvis(values.staffCategory);
    newAsset.asset.details = elvis(values.details);
    newAsset.valid = isValid;
    props.parentCallback(newAsset);
  };

  return (
    <Form 
      form={form}
      {...formItemLayout} 
      className="details_form"
      onValuesChange={handleFormChange}
      onFieldsChange={handleFormChange}
    >
      <Title 
        className="details_form_header"
        title="Asset details"
        subTitle="Working Staff"
      />
      
      <Form.Item 
        label="Total number" 
        name="number"
        rules={isEditMode ? [{ required: false }] : []}
      >
        <InputNumber disabled={!isEditMode} />
      </Form.Item>

      <Form.Item label="Category" name="staffCategory">
        <Select disabled={!isEditMode} allowClear>
          {staffCategories.map(name => (
            <Option key={name} value={name}>{t("businessEnums.staffCategory." + name, name)}</Option>
          ))}
        </Select>
      </Form.Item>

      <Form.Item
        label="Activities performed"
        name="activities"
        rules={isEditMode ? [{ required: false }] : []}
      >
        <Input disabled={!isEditMode} />
      </Form.Item>
      
      <Form.Item 
        label="Details" 
        name="details"
        rules={isEditMode ? [{ required: false }] : []}
      >
        <Input disabled={!isEditMode} />
      </Form.Item>
    </Form>
  );
};

export default StaffForm;